module.exports = __webpack_public_path__ + "static/ps2-20ef67e9c9587b300e8b2ac5b724c60e.jpg";